import Vue from "vue";

export const state = Vue.observable({
  isLogin: false,
  keyword: "",
  aboutUsId: "1",
  announcementId: "1",
  servicehallId: "1",
  phoneNumber: "",
  userName: "",
  miniProgramPersonId: "",
  profilePhoto: ""
});

const store = {
  state,
  setLoginStatus(isLogin) {
    state.isLogin = isLogin;
  },
  setKeyword(keyword) {
    state.keyword = keyword;
  },
  setAboutUsId(aboutUsId) {
    state.aboutUsId = aboutUsId;
  },
  setAnnouncementId(announcementId) {
    state.announcementId = announcementId;
  },
  setServicehallId(servicehallId) {
    state.servicehallId = servicehallId;
  },
  setPhoneNumber(phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
  setUserName(userName) {
    state.userName = userName;
  },
  setMiniProgramPersonId(miniProgramPersonId) {
    state.miniProgramPersonId = miniProgramPersonId;
  },
  setProfilePhoto(profilePhoto) {
    state.profilePhoto = profilePhoto;
  },
  expireLogin() {
    state.isLogin = false;
    state.keyword = "";
    state.aboutUsId = "";
    state.announcementId = "";
    state.servicehallId = "";
    state.phoneNumber = "";
    state.userName = "";
    state.miniProgramPersonId = "";
    state.profilePhoto = "";
  }
};

export default store;

window.addEventListener("beforeunload", () => {
  localStorage.setItem("account", JSON.stringify(state));
});


try {
  var account = JSON.parse(localStorage.getItem("account"));
  state.isLogin = account.isLogin;
  state.phoneNumber = account.phoneNumber;
  state.userName = account.userName;
  state.miniProgramPersonId = account.miniProgramPersonId;
  state.profilePhoto = account.profilePhoto;
} catch (error) {
  account = {};
}
